import { useVForm } from "@/CommonDP/VForm/utils";
import upload from "./upload/index.js";
import { schema as user, singleSchema as singleUser } from "./user/index.js";
import { schema as dept, single as singleDept } from "./dept/index.js";
import { schema as calc } from "./calc/index.js";
import { schema as JyDir } from './saveDirectory/index.js';
import { schema as JySpec } from './spec/index.js';
import { schema as JyStage } from './stage/index.js';
import { schema as JyChild } from './child/index.js';
import { schema as dict, singleDict } from "./dict/index.js";
import { schema as JyTableSelect } from "./select/index.js";
import { schema as city } from "./city/index.js";
import { schema as identifier } from "./identifier/index.js";
import { schema as html } from "./html/index.js";
import { schema as prjId } from "./prjId/schema.js";
import { schema as prjNameShow } from "./prjNameShow/schema.js";
import { schema as testVue } from "./vue/schema.js";
import { schema as subformJyht } from "./container/subformJyht/index.js";
import { schema as JyTable } from "./jyhtTable/index.js";
import { resetSwitch } from "./switch/index.js";
import { resetNumber } from "./number/index.js";
import { schema as JyFolder } from "./folder/schema.js";
import { resetDate } from "./date/index.js";
import { replacePanel } from "./utils/panel-setting/register.js";
export default () => {
  useVForm(() => {
    return [
      html,
      upload,
      JyDir,
      JyFolder,
      singleUser,
      user,
      singleDict,
      dict,
      dept,
      JySpec,
      JyStage,
      JyChild,
      city,
      identifier,
      JyTableSelect,
      prjId,
      singleDept,
      prjNameShow,
      subformJyht,
      calc,
      testVue,
      JyTable
    ];
  });
  resetSwitch();
  resetNumber();
  resetDate();
  replacePanel();
};
